export enum EventsInformationActionTypes {
  REQUEST_EVENTS_INFORMATION = '@@events-information/REQUEST_EVENTS_INFORMATION',
  REQUEST_EVENT_INFORMATION_SUCCESS = '@@events-information/REQUEST_EVENTS_INFORMATION_SUCCESS',
  REQUEST_EVENT_INFORMATION_FAILED = '@@events-information/REQUEST_EVENTS_INFORMATION_FAILED',
  SET_SEARCH_TERM = '@@event-information/SET_SEARCH_TERM',
}
